/* eslint-disable promise/param-names */
import Vue from 'vue'
import axios from 'axios'
import {
  SURVEY_ADD_TARGETS_REQUEST,
  SURVEY_ADD_TARGETS_ERROR,
  SURVEY_ADD_TARGETS_SUCCESS,
  GET_SURVEYS_ERROR,
  GET_SURVEYS_REQUEST,
  GET_SURVEYS_SUCCESS,
  ADD_SURVEY_ERROR,
  ADD_SURVEY_REQUEST,
  ADD_SURVEY_SUCCESS,
  SURVEY_SAVE_OPTION_ERROR,
  SURVEY_SAVE_OPTION_REQUEST,
  SURVEY_SAVE_OPTION_SUCCESS,
  GET_SURVEY_REQUEST,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_ERROR,
  ASSIGN_SURVEYS_TO_PARTNER_ERROR,
  ASSIGN_SURVEYS_TO_PARTNER_REQUEST,
  ASSIGN_SURVEYS_TO_PARTNER_SUCCESS,
  GET_PROVIDER_SURVEYS_ERROR,
  GET_PROVIDER_SURVEYS_REQUEST,
  GET_PROVIDER_SURVEYS_SUCCESS,
  SURVEYS_ADD_RAW_RESULT_ERROR,
  SURVEYS_ADD_RAW_RESULT_REQUEST,
  SURVEYS_ADD_RAW_RESULT_SUCCESS,
  PROVIDER_CUSTOM_TEMPLATE_REQUEST,
  PROVIDER_CUSTOM_TEMPLATE_SUCCESS,
  PROVIDER_CUSTOM_TEMPLATE_ERROR, RRH_CUSTOM_TEMPLATE_SUCCESS, RRH_CUSTOM_TEMPLATE_ERROR, RRH_CUSTOM_TEMPLATE_REQUEST,
  GET_REPORTING_REQUEST, GET_REPORTING_ERROR, GET_REPORTING_SUCCESS
} from './actiontypes';
import surveyApi from '../../_services/api/survey';

const state = {
  providerTemplate: '',
  rrhTemplate: '',
  reporting:'',
  surveys: [],
  survey: {},
  status: '',
  errors: [],
  hasLoadedOnce: false,
};

const getters = {
  surveys: state => state.surveys,
  survey: state => state.survey,
  providerTemplate: state => state.providerTemplate,
  rrhTemplate: state => state.providerTemplate
};

const actions = {
  [GET_PROVIDER_SURVEYS_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_SURVEYS_REQUEST);
      surveyApi.getProviderSurveys(payload)
          .then((response) => {
            if (response.success === true) {
              commit(GET_PROVIDER_SURVEYS_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(GET_PROVIDER_SURVEYS_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(GET_SURVEYS_ERROR, error);
            reject(error);
          });
    });
  },
  [GET_REPORTING_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_REPORTING_REQUEST);
      surveyApi.getReporting(payload)
          .then((response) => {
            if (response.success === true) {
              commit(GET_REPORTING_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(GET_REPORTING_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(GET_REPORTING_ERROR, error);
            reject(error);
          });
    });
  },
  [RRH_CUSTOM_TEMPLATE_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(RRH_CUSTOM_TEMPLATE_REQUEST);
      surveyApi.rrhCustomTemplate(payload)
          .then((response) => {
            if (response.success === true) {
              commit(RRH_CUSTOM_TEMPLATE_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(RRH_CUSTOM_TEMPLATE_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(RRH_CUSTOM_TEMPLATE_ERROR, error);
            reject(error);
          });
    });
  },
  [PROVIDER_CUSTOM_TEMPLATE_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(PROVIDER_CUSTOM_TEMPLATE_REQUEST);
      surveyApi.providerCustomTemplate(payload)
          .then((response) => {
            if (response.success === true) {
              commit(PROVIDER_CUSTOM_TEMPLATE_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(PROVIDER_CUSTOM_TEMPLATE_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(PROVIDER_CUSTOM_TEMPLATE_ERROR, error);
            reject(error);
          });
    });
  },
  [ASSIGN_SURVEYS_TO_PARTNER_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      surveyApi.assignPartnerToSurveys(payload)
          .then((response) => {
            if (response.success === true) {
              commit(ASSIGN_SURVEYS_TO_PARTNER_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(ASSIGN_SURVEYS_TO_PARTNER_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(SURVEY_SAVE_OPTION_ERROR, error);
            reject(error);
          });
    });
  },
  [SURVEYS_ADD_RAW_RESULT_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      surveyApi.addRawResults(payload)
          .then((response) => {
            if (response.success === true) {
              commit(SURVEYS_ADD_RAW_RESULT_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(SURVEYS_ADD_RAW_RESULT_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(SURVEY_SAVE_OPTION_ERROR, error);
            reject(error);
          });
    });
  },
  [SURVEY_ADD_TARGETS_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      surveyApi.addSurveyTargets(payload)
          .then((response) => {
            if (response.success === true) {
              commit(SURVEY_ADD_TARGETS_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(SURVEY_ADD_TARGETS_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(SURVEY_SAVE_OPTION_ERROR, error);
            reject(error);
          });
    });
  },
  [SURVEY_SAVE_OPTION_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      surveyApi.saveSurveyOption(payload)
          .then((response) => {
            if (response.success === true) {
              commit(SURVEY_SAVE_OPTION_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(SURVEY_SAVE_OPTION_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(SURVEY_SAVE_OPTION_ERROR, error);
            reject(error);
          });
    });
  },
  [GET_SURVEY_REQUEST]: ({ commit, dispatch }, id) => {
    return new Promise((resolve, reject) => {
      surveyApi.getSurvey(id)
          .then((response) => {
            if (response.success === true) {
              commit(GET_SURVEY_SUCCESS, response.data);
              resolve(response);
            } else {
              commit(GET_SURVEY_ERROR, response);
              reject(response.error);
            }
          })
          .catch((error) => {
            commit(GET_SURVEYS_ERROR, error);
            reject(error);
          });
    });
  },
  [GET_SURVEYS_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_SURVEYS_REQUEST);
      surveyApi.getSurveys(payload)
        .then((response) => {
          if (response.success === true) {
            commit(GET_SURVEYS_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(GET_SURVEYS_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(GET_SURVEYS_ERROR, error);
          reject(error);
        });
    });
  },
  [ADD_SURVEY_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADD_SURVEY_REQUEST);
      surveyApi.addSurvey(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADD_SURVEY_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADD_SURVEY_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADD_SURVEY_ERROR, error);
          reject(error);
        });
    });
  },
};

const mutations = {
  [GET_REPORTING_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'reporting', response.encoded_string.file);
  },
  [GET_REPORTING_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [GET_REPORTING_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [RRH_CUSTOM_TEMPLATE_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [RRH_CUSTOM_TEMPLATE_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [RRH_CUSTOM_TEMPLATE_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'rrhTemplate', response.encoded_string.file);
  },
  [RRH_CUSTOM_TEMPLATE_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [RRH_CUSTOM_TEMPLATE_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [PROVIDER_CUSTOM_TEMPLATE_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'providerTemplate', response.encoded_string.file);
  },
  [PROVIDER_CUSTOM_TEMPLATE_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [PROVIDER_CUSTOM_TEMPLATE_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ASSIGN_SURVEYS_TO_PARTNER_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ASSIGN_SURVEYS_TO_PARTNER_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ASSIGN_SURVEYS_TO_PARTNER_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [SURVEY_ADD_TARGETS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [SURVEY_ADD_TARGETS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [SURVEY_ADD_TARGETS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [SURVEYS_ADD_RAW_RESULT_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [SURVEYS_ADD_RAW_RESULT_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [SURVEYS_ADD_RAW_RESULT_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [SURVEY_SAVE_OPTION_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADD_SURVEY_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADD_SURVEY_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [GET_SURVEY_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_SURVEY_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'survey', response.survey);
  },
  [GET_SURVEY_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [GET_PROVIDER_SURVEYS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_PROVIDER_SURVEYS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'surveys', response.surveys);
  },
  [GET_PROVIDER_SURVEYS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [GET_SURVEYS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_SURVEYS_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'surveys', response.surveys);
  },
  [GET_SURVEYS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADD_SURVEY_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADD_SURVEY_SUCCESS]: (state, response) => {
    state.status = 'success';;
    state.hasLoadedOnce = true;
  },
  [ADD_SURVEY_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    console.log(response);
    Vue.set(state, 'errors', response.error);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
